import QuickSearches from 'QuickSearches/components/QuickSearches'
import UsageStats from 'Dashboard/components/UsageStats'
import useActions from 'Dashboard/useActions'
import AnalyticsQuery from 'AnalyticsDashboard/components/AnalyticsQuery'
import AnalyticsProvider from 'AnalyticsDashboard/components/AnalyticsProvider'

export default function PageContainer({ admin = false, manageAudiences = false }) {
  useActions()
  const firstName = useSel((s) => s.currentUser.firstName)
  const analytics = window.ENV.USER_PREFERENCES.enable_experimental_analytics
  const map = window.ENV.CLIENT_LANGUAGES.length <= 1 && window.ENV.COUNTRY === 'gb' ? 'uk' : 'world'

  return (
    <>
      <div className='row'>
        <div className={`column ${analytics ? 'two-thirds' : 'remaining'}`}>
          <div className="title">
            <h1>Hello {firstName}</h1>
            <p className="larger dark-grey">
              There's nothing like some graphs to start your day <SvgIconsRocket />
            </p>
          </div>
          {manageAudiences && (
            <div className="section no-margin-bottom">
              <h2>Quick start</h2>
              <p className="larger dark-grey">
                Click below to quickly create a text or calling campaign to one of your
                favourite audiences.
              </p>
              <QuickSearches create={admin} />
            </div>
          )}
        </div>
        { analytics && <div className='column third'>
          <AnalyticsProvider uiEnabled={false}>
            { map === 'world' && <AnalyticsQuery chartType='mapWorld' metrics={[{ id: 'm1', factTable: 'targets', column: '*', operation: 'count' }]} primaryDimension={{ id: 'targets_country', label: 'Country' }} dimensions={[{ id: 'targets_country' }]} chartOptions={{ columns: [{ id: 'targetsCountry', label: 'Country' }, { id: 'm1', kind: 'number', label: 'Count' }] }} /> }
            { map === 'uk' && <AnalyticsQuery chartType='map' metrics={[{ id: 'm1', factTable: 'targets', column: '*', operation: 'count' }]} primaryDimension={{ id: 'westminster_constituency', label: 'Westminster Constituency' }} dimensions={[{ id: 'westminster_constituency' }]} chartOptions={{ columns: [{ id: 'westminsterConstituency', label: 'Westminster Constituency' }, { id: 'm1', kind: 'number', label: 'Count' }] }} /> }
            <div className='text-center light italic'>Your audience</div>
          </AnalyticsProvider>
        </div> }
      </div>


      <div className="section">
        <h2>Your Activity</h2>
        <UsageStats />
      </div>
    </>
  )
}
